import React from "react";

//package import

import { Navigate, useLocation } from "react-router-dom";
import { decodeToken, isExpired } from "react-jwt";
import { ADMIN_ROUTES, MainRoutes, NAV_ROUTES } from "./index";
import { StorageKeys } from "../../Storage/index";
import { USER_ROLES_ENUM } from "../../Enums";
import { Login } from "../../../pages";

export const PrivateRoute = ({ element: Component, ...rest }) => {
  //hooks
  const auth = useAuth();

  return auth ? <Component {...rest} /> : <Navigate to={MainRoutes?.root} />;
};

export const RouteComponent = ({ element: Component, ...rest }) => {
  return <Component {...rest} />;
};

export const PrivateRouteWrapper = ({ children }) => {
  //hooks
  const auth = useAuth();
  return auth ? children : <Navigate to={MainRoutes?.root} />;
};

export const useAuth = () => {
  const token = localStorage.getItem(StorageKeys?.token);
  const { pathname } = useLocation();

  const validToken = validatedDecodedToken(token);

  if (validToken?.role) {
    return verifyRole(validToken?.role, pathname);
  }

  localStorage.clear();
  return false;
};

const verifyRole = (role, pathname) => {
  const user_role = role?.toLowerCase();

  return (
    (pathname.includes(USER_ROLES_ENUM.admin) &&
      user_role.includes(USER_ROLES_ENUM.admin)) ||
    (user_role.includes(USER_ROLES_ENUM.user) &&
      !pathname.includes(USER_ROLES_ENUM.admin))
  );
};

export const getDecodedToken = (t) => {
  const token = t ? t : localStorage.getItem(StorageKeys?.token);

  const validToken = validatedDecodedToken(token);
  if (validToken) {
    return validToken;
  }

  localStorage.clear();
  return false;
};

export const useDecodedToken = () => {
  return getDecodedToken();
};

export const resetToken = (t) => {
  if (validatedDecodedToken(t)) {
    localStorage.setItem(StorageKeys?.token, t);
    return true;
  }
  return false;
};

const validatedDecodedToken = (token) => {
  if (token) {
    //checking token is expired or not
    const expired = isExpired(token);

    if (!expired) {
      //decoding token is expired or not
      const decodedToken = decodeToken(token);
      if (decodedToken) {
        return { ...decodedToken };
      }
    }
  }
  return false;
};

export default PrivateRoute;
